// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"146":"5864efcd","492":"e80c11f0"}[chunkId] + ".chunk.css";
};